import { GamesService, InteractiveGameService } from '@pbl/pbl-react-core/lib/services';
import constants from 'config/constants';
import { showMessageBar } from '../app/actions';

export const GET_GAME_CONFIG = 'interactive-games/GET_GAME_CONFIG';
export const UPDATE_GAME_CONFIG = 'interactive-games/UPDATE_GAME_CONFIG';
export const GET_PLAY_FOR_POINTS_ACTIVITY = 'interactive-games/GET_PLAY_FOR_POINTS_ACTIVITY';
export const FETCH_DIGITAL_REVEAL_PLAYABLE = 'interactive-games/FETCH_DIGITAL_REVEAL_PLAYABLE';
export const START_GAME = 'interactive-games/START_GAME';
export const END_GAME = 'interactive-games/END_GAME';
export const SKIP_GAME = 'interactive-games/END_GAME';

export const updateGame = (gameConfigId: string) => (dispatch: any) => {
  dispatch({
    type: UPDATE_GAME_CONFIG,
    payload: GamesService.updateGame(gameConfigId)
  }).catch(error => {
    dispatch(showMessageBar({ message: error.payload ? error.payload.errorKey : 'Error to load game config', type: 'error' }));
  });
};

export const startGame = (digitalRevealToken: string) => (dispatch: any) => {
  dispatch({
    type: START_GAME,
    payload: InteractiveGameService.startGame(digitalRevealToken)
  }).catch(error => {
    dispatch(showMessageBar({ message: error.payload.errorKey, type: 'error' }));
  });
};

export const endGame = (digitalRevealToken: string) => (dispatch: any) => {
  dispatch({
    type: END_GAME,
    payload: InteractiveGameService.endGame(digitalRevealToken)
  }).catch(error => {
    dispatch(showMessageBar({ message: error.payload.errorKey, type: 'error' }));
  });
};

export const skipGame = (digitalRevealToken: string) => (dispatch: any) => {
  dispatch({
    type: SKIP_GAME,
    payload: InteractiveGameService.skipGame(digitalRevealToken)
  }).catch(error => {
    dispatch(showMessageBar({ message: error.payload.errorKey, type: 'error' }));
  });
};

export const fetchPlayableDigitalRevealGames = (page: number) => async (dispatch: any) => {
  try {
    dispatch({
      type: FETCH_DIGITAL_REVEAL_PLAYABLE,
      payload: InteractiveGameService.getPlayableTokens(constants.HISTORY_ITEMS_PER_PAGE, page)
    });
  } catch (e: any) {
    dispatch(showMessageBar({ message: e.payload.errorKey, type: 'error' }));
  }
};
